import { render, staticRenderFns } from "./SaleCommissionForm.vue?vue&type=template&id=05ca0924"
import script from "./SaleCommissionForm.vue?vue&type=script&lang=js"
export * from "./SaleCommissionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports